import Products_F_0 from './Products_F/Products_F_0'
import Products_F_2 from './Products_F/Products_F_2'
import Products_F_3 from './Products_F/Products_F_3'
import Products_F_6 from './Products_F/Products_F_6'
import Products_F_7 from './Products_F/Products_F_7'

const Products_F = [
  Products_F_0,
  null,
  Products_F_2,
  Products_F_3,
  null,
  null,
  Products_F_6,
  Products_F_7
]
export default Products_F



// WEBPACK FOOTER //
// ./src/components/Products_F.js